var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (artists, undefined) {
buf.push("<div class=\"artist-fillwidth-list\">");
// iterate artists
;(function(){
  var $$obj = artists;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var artist = $$obj[$index];

if ( artist.get('id'))
{
buf.push("<div" + (jade.attr("data-id", artist.get('id'), true, true)) + " class=\"artist-fillwidth-list-item\"><h4><a" + (jade.attr("href", artist.href(), true, true)) + " class=\"faux-underline-hover-large\">" + (jade.escape(null == (jade_interp = artist.get('name')) ? "" : jade_interp)) + "</a></h4><div class=\"plus-follow-button\"><div class=\"icon-follow-circle\"></div><div class=\"follow-button-text\"></div></div><div class=\"artist-fillwidth-list-artworks\"><div class=\"loading-spinner\"></div></div></div>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var artist = $$obj[$index];

if ( artist.get('id'))
{
buf.push("<div" + (jade.attr("data-id", artist.get('id'), true, true)) + " class=\"artist-fillwidth-list-item\"><h4><a" + (jade.attr("href", artist.href(), true, true)) + " class=\"faux-underline-hover-large\">" + (jade.escape(null == (jade_interp = artist.get('name')) ? "" : jade_interp)) + "</a></h4><div class=\"plus-follow-button\"><div class=\"icon-follow-circle\"></div><div class=\"follow-button-text\"></div></div><div class=\"artist-fillwidth-list-artworks\"><div class=\"loading-spinner\"></div></div></div>");
}
    }

  }
}).call(this);

buf.push("</div><div class=\"artist-fillwidth-list-see-more\"><div class=\"avant-garde-button-text\">See More</div></div>");}.call(this,"artists" in locals_for_with?locals_for_with.artists:typeof artists!=="undefined"?artists:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;